import { Colors, Icon } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { CustomLink } from "@/components/pieces/SmartLinkMarkdown";
import { CARD_CLASSES } from "@/css/constants";

export function UrlLink({ url = "", text = "", onClick = () => {} }) {
  return (
    <Flex
      className={CARD_CLASSES}
      css={{ background: Colors.WHITE }}
      p={2}
      alignItems="center"
    >
      <Icon icon="link" color={Colors.GRAY3} size={16} />

      <Clickable onClick={onClick}>
        <Box
          ml={2}
          fontWeight={700}
          css={{
            whiteSpace: "break-spaces",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <CustomLink href={url}>{text || url}</CustomLink>
        </Box>
      </Clickable>
    </Flex>
  );
}
